
import { ApiCrudObjectControllerBindings, Payroll4CrudController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * EXPERIMENTAL new version of the Payroll Details component.
 * Payroll (Palkkalista) is a list of employees who receive salary or wages from a particular organization.
 * Typical usecase is that a a company has e.g. a monthly salary list that is paid
 * at the end of month. For next month, a copy is then made from the latest list and
 * the copy is potentially modified with the changes of that particular month.
 * Payroll can also be started from scratch either by just writing salaries from
 * e.g. an e-mail or by uploading an Excel sheet.
 * @example
 * ```html
 * <salaxy-payroll-details></salaxy-payroll-details>
 * ```
 */
export class PayrollDetails extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = (new class extends ApiCrudObjectControllerBindings {
    /** The action buttons shown by the component */
    actions = "<";
    /** Currently selected tab in the Payroll  */
    payrollDetailsCurrentTab = "@";
    /** Custom default tab. */
    defaultTab = "@";
  }());

  /** Uses the PayrollCrudController */
  public controller = Payroll4CrudController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/calc/payrollV4/PayrollDetails.html";
}
